const FontFamily = {
  Inter: 'Inter, Inter-Regular, Sora, Inter-Bold',
  Sora: 'Sora',
}

export default FontFamily
